export default __webpack_public_path__ + "43ded96f077e9896f4ac206d499d3f0d.png";